export default __webpack_public_path__ + "static/media/infinitelyExtensible.0a4872e8.png";